import React, { createContext } from 'react';
import { ILoggedInAccessState } from '../../types/rbac/ILoggedInAccessState';

export const AccessContext = createContext<ILoggedInAccessState | null>(null);

export const PUBLIC_UNGATED_ACCESS: ILoggedInAccessState = {
  status: 'ready',
  menuGuardEnabled: false,
  allowedPaths: [],
  rolePermissions: [],
  menus: [],
};

interface IAccessProviderProps {
  access: ILoggedInAccessState;
  children: React.ReactNode;
}

export const AccessProvider: React.FC<IAccessProviderProps> = ({ access, children }) => (
  <AccessContext.Provider value={access}>{children}</AccessContext.Provider>
);

export default AccessProvider;
